// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Z1Z5","header":"ClearentDisclaimer_header__ofdsE","inner":"ClearentDisclaimer_inner__WtId4"};